module.exports = __webpack_public_path__ + "img/pl.1f9d98ad.svg";